export const MinusCircle = () => (
  <svg height="16" viewBox="0 0 17 16" width="17" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.16683 7.3335V8.66683H11.8335V7.3335H5.16683ZM8.50016 1.3335C4.82016 1.3335 1.8335 4.32016 1.8335 8.00016C1.8335 11.6802 4.82016 14.6668 8.50016 14.6668C12.1802 14.6668 15.1668 11.6802 15.1668 8.00016C15.1668 4.32016 12.1802 1.3335 8.50016 1.3335ZM8.50016 13.3335C5.56016 13.3335 3.16683 10.9402 3.16683 8.00016C3.16683 5.06016 5.56016 2.66683 8.50016 2.66683C11.4402 2.66683 13.8335 5.06016 13.8335 8.00016C13.8335 10.9402 11.4402 13.3335 8.50016 13.3335Z"
      fill="currentColor"
    />
  </svg>
)
